import { WithdrawalType } from "../enums/withdrawalType.enum";

interface WithdrawalOptions {
  name: string;
  description: string;
  type: WithdrawalType;
}

export const WITHDRAWAL_OPTIONS: WithdrawalOptions[] = [
  {
    name: "Partial Withdrawal",
    description: "Request part of the funds raised",
    type: WithdrawalType.partial,
  },
  {
    name: "Full Withdrawal",
    description: "Cash it all out",
    type: WithdrawalType.complete,
  },
];
export default WITHDRAWAL_OPTIONS;
